/**
 * Основание платежа — категория того что оплачивается (сырьё, упаковка и т.д.)
 * Таблица: catalog.payment_reason_bases
 */
class PaymentReasonBasis {

    /* Идентификатор */
    public id: number;
    /* Наименование основания */
    public value: string;
    /* Код страны */
    public countryCode: string;

    static fromServer(data: any, result = new PaymentReasonBasis()): PaymentReasonBasis {

        result.id          = data.id;
        result.value       = data.value;
        result.countryCode = data.countryCode;

        return result;
    }

    /** Представление в селектах (VSelectV2 рендерит toString) */
    toString(): string {
        return this.value;
    }

    /* Метод форматирования чейджлога */
    static formatDiff (oldValue: PaymentReasonBasis | null, newValue: PaymentReasonBasis | null): string {
        let result = '';

        if (oldValue?.value) {
            result += ` c "${oldValue.value}"`;
        }

        if (newValue?.value) {
            result += ` на "${newValue.value}"`;
        }

        return result;
    }
}

export default PaymentReasonBasis;